import axios from "axios";
import authHeader from '../../../authheader'

const EINOTIFICATIONPREFERENCEURL = process.env.REACT_APP_APIURL + "/api/NotificationPreferences";


const getPrivacyData = (entityId) => {
    return axios.get(`${EINOTIFICATIONPREFERENCEURL}/journalandprivacy`, { headers: authHeader(), params: { entityId } });
}
const postPrivacyData = (data) => {
    return axios.post(`${EINOTIFICATIONPREFERENCEURL}/journalandprivacy`, data, { headers: authHeader() });
}
export default {
    getPrivacyData,
    postPrivacyData
}